(function () {
  if (window.__saLandingInit) return;
  window.__saLandingInit = true;

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.sa-cta') : null;
    if (!a) return;
    var btn = document.getElementById('es-popup-button') ||
              document.querySelector('.es-popup-button, .es-popup-button-product');
    if (btn) { e.preventDefault(); btn.click(); return; }
    var f = document.getElementById('es-form-container') || document.getElementById('es-form');
    if (f) { e.preventDefault(); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, true);

  function fechas() {
    try {
      var M = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      var fmt = function (d) { return d.getDate() + ' ' + M[d.getMonth()]; };
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var nodes = document.querySelectorAll('[data-sa-date]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var n = parseInt(el.getAttribute('data-sa-date'), 10);
        var to = el.getAttribute('data-sa-date-to');
        if (n === 0) el.textContent = 'Hoy, ' + fmt(new Date());
        else if (to) el.textContent = fmt(add(n)) + ' – ' + fmt(add(parseInt(to, 10)));
        else el.textContent = fmt(add(n));
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fechas);
  else fechas();
  document.addEventListener('shopify:section:load', fechas);
})();